import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { CaseStudy } from './pages/CaseStudy';
import { Services } from './pages/Services';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
type HeroVariant = 'overlap' | 'stacked' | 'editorial';
interface AppProps {
  heroVariant?: HeroVariant;
}
export function App({
  heroVariant = 'overlap'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="31aqfuglwour9">
      <Routes data-id="element-1" data-mp="31b8lu4ydencd">
        <Route element={<Layout data-id="element-3" data-mp="31bi8bik7icdb" />} data-id="element-2" data-mp="31bs1ff0jszn8">
          <Route path="/" element={<Home heroVariant={heroVariant} data-id="element-5" data-mp="2wk0av4he6tx3" />} data-id="element-4" data-mp="31ctdnmtavs6j" />
          <Route path="/work" element={<Work data-id="element-7" data-mp="2whxbhtucnofp" />} data-id="element-6" data-mp="2wj8f9tnsow6t" />
          <Route path="/work/:slug" element={<CaseStudy data-id="element-9" data-mp="28te1n9vnj3li" />} data-id="element-8" data-mp="28ufmg62gz4gf" />
          <Route path="/services" element={<Services data-id="element-11" data-mp="23vchelmhoy8g" />} data-id="element-10" data-mp="28sl3gxardmez" />
          <Route path="/pricing" element={<Pricing data-id="element-13" data-mp="23utby4e102bb" />} data-id="element-12" data-mp="23w4fc33k781w" />
          <Route path="/about" element={<About data-id="element-15" data-mp="3ik7jmqgv0tve" />} data-id="element-14" data-mp="23t8eo70bu59r" />
          <Route path="/contact" element={<Contact data-id="element-17" data-mp="3ijpcuzwkmx98" />} data-id="element-16" data-mp="3iiweonbohg2p" />
          <Route path="*" element={<Home heroVariant={heroVariant} data-id="element-19" data-mp="3ml12h5fg3ihf" />} data-id="element-18" data-mp="3mlj9mx3nbh44" />
        </Route>
      </Routes>
    </BrowserRouter>;
}